<template>
    <!-- order form modal -->
    <div id="customConfirmationDialog" v-if="isOrderFormModalOpen">
        <div @click="() => isOrderFormModalOpen = false && this.$forceUpdate() && changeOrderModalState(false) && this.$destroy() && isNewOrder === true ? quantity = parseInt(localStorage.getItem('maxQuantity'), 10) || 1 : quantity = parseInt(this.QuantityBeforeEdit, 10)"
            :class="`modal-backdrop ${isOrderFormModalOpen ? '' : 'hidden'}`">
        </div>
        <div id="popupModal" tabindex="-1">
            <!-- modal body -->
            <div class="fixed top-0 right-0 z-[150] h-full sm:w-full w-[90%] max-w-xl max-h-full">
                <div class="relative bg-white modal_inner_dialog h-full">
                    <img  @click="() => isOrderFormModalOpen = false && changeOrderModalState(false) && this.$destroy()" class="w-[22px] h-[22px] block absolute left-4 top-4 cursor-pointer" src="../../../assets/icons/times.svg" alt="">
                    <div >
                        <Breadcrumb :links="breadcrumbLinks" />
                    </div>
                    <h1 v-if="isNewOrder && !this.$route.query.productItem" 
                        class="text-xl font-bold p-4 md:p-6 text-gray-800 border-b border-gray-200">
                        <span class="mr-2">{{ $t('general.order_details') }}:</span>
                        <span class="text-primary">{{ totalPrice() }} {{ $t('general.pound') }}</span>
                    </h1>
                    <h1 v-else 
                        class="text-xl font-bold p-4 md:p-6 text-gray-800 border-b border-gray-200">
                        {{ $t('general.order_details') }}
                    </h1>
                    <div class="flex items-center gap-6 p-5 rounded-xl m-4 bg-[#f3f4f6] hover:bg-[#ebedf0] transition-colors">
                        <div class="relative">
                            <img 
                                :src="productData.image" 
                                class="w-28 h-28 object-contain rounded-xl shadow-md bg-white p-3 transition-transform hover:scale-105" 
                                :alt="currentLanguage === 'ar' ? productData.name_ar : productData.name_en"
                            >
                        </div>
                        <div class="flex flex-col flex-1">
                            <h3 class="text-base font-semibold text-gray-800 mb-2">
                                {{ currentLanguage === 'ar' ? productData.name_ar : productData.name_en }}
                            </h3>
                        </div>
                    </div>
                    <div class="p-[1.1rem_1.5rem] md:p-[1.4rem_1.7rem] h-[60%] overflow-auto sm:h-[70%] ">
                        <form @submit.prevent="() => makeOrder()">
                            <div>
                                <!-- Render segments based on quantity -->
                                <div v-if="!this.$route.productItem" v-for="(segment, index) in quantitySegments" :key="index" class="mt-2" >
                                    <label v-if="segment.quantity !== 0" class="text-black inline-block text-[12px] md:text-[13.5px] mb-1.5" for="quantity">
                                        {{$t('general.num_pieces') }}
                                    </label>
                                    <div v-if="segment.quantity !== 0" class="relative max-w-[280px] w-full h-[50px] flex">
                                        <button @click="increaseQuantity(index)" :disabled="true" 
                                            class="rounded-[11px] text-[24px] absolute bg-white top-0 right-0 z-10 border border-[#E5E5E5] h-[50px] w-[50px] flex items-center justify-center">+</button>
                                        <input @input="validateQuantity($event, index)" type="number" v-model="segment.quantity" min="0"
                                            class="w-full border border-[#E5E5E5] rounded-[11px] text-center flex items-center justify-center text-[24px] focus:border-[#E5E5E5] focus:outline-none">
                                        <button @click="decreaseQuantity(index)" 
                                            class="absolute top-0 text-[24px] left-0 z-10 bg-[#E5E5E5] rounded-[11px] h-[50px] w-[50px] flex items-center justify-center">-</button>
                                    </div>
                                    <!-- Render attributes for this segment -->
                                    <div v-if="isNewOrder === true || segment.quantity !== 0" :class="`mt-6 mb-4 pb-4 border-b-[2px] ${attributes.length == (index+1) && 'border-none'}`" v-for="(main, idx) in segment.attributes" :key="idx">
                                        <label v-if="segment.quantity !== 0" class="mb-4 block text-[#6A6A6A]">{{ main.name }} :</label>
                                        <ul v-if="segment.quantity !== 0" class="flex flex-wrap gap-[20px]">
                                            <li v-for="(sub, i) in main.children" :key="i">
                                                <span v-if="sub.isColor" @click="changeSelect(main.id, sub.id, index)" :class="`cursor-pointer block h-[50px] w-[50px] rounded-[11px] p-2 ${ sub.isSelected ? 'border border-[#956113] border-[3px]' : ''}`" :style="{ backgroundColor: sub.color }"></span>
                                                <span v-else-if="main.display_as_text === 0" @click="changeSelect(main.id, sub.id, index)" :class="`${sub.isSelected ? 'bg-[#0963FF] text-white' : 'border-[#a5a5a5] border-[1px]'} border h-[50px] flex items-center px-4 cursor-pointer min-w-[60px] rounded-[11px] text-center`">{{ currentLanguage === 'ar' ? sub.name_ar : sub.name_en }}</span>
                                                <span v-else class="bg-primaryLight3 text-primary py-[0.220rem] px-2 rounded-[0.375rem]">{{ currentLanguage === 'ar' ? sub.name_ar : sub.name_en }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <!-- Render segments based on quantity -->
                                <div v-if="this.$route.productItem" v-for="(segment, index) in quantitySegments" :key="index" class="mt-2" >
                                    <label v-if="segment.quantity !== 0" class="text-black inline-block text-[12px] md:text-[13.5px] mb-1.5" for="quantity">
                                        {{$t('general.num_pieces') }}
                                    </label>
                                    <div v-if="segment.quantity !== 0" class="relative max-w-[280px] w-full h-[50px] flex">
                                        <button @click="increaseQuantity(index)" :disabled="true" 
                                            class="rounded-[11px] text-[24px] absolute bg-white top-0 right-0 z-10 border border-[#E5E5E5] h-[50px] w-[50px] flex items-center justify-center">+</button>
                                        <input @input="validateQuantity($event, index)" type="number" v-model="segment.quantity" min="0"
                                            class="w-full border border-[#E5E5E5] rounded-[11px] text-center flex items-center justify-center text-[24px] focus:border-[#E5E5E5] focus:outline-none">
                                        <button @click="decreaseQuantity(index)" 
                                            class="absolute top-0 text-[24px] left-0 z-10 bg-[#E5E5E5] rounded-[11px] h-[50px] w-[50px] flex items-center justify-center">-</button>
                                    </div>
                                    <!-- Render attributes for this segment -->
                                    <div v-if="isNewOrder === true || segment.quantity !== 0" :class="`mt-6 mb-4 pb-4 border-b-[2px] ${attributes.length == (index+1) && 'border-none'}`" v-for="(main, idx) in segment.attributes" :key="idx">
                                        <label v-if="segment.quantity !== 0" class="mb-4 block text-[#6A6A6A]">{{ main.name }} :</label>
                                        <ul v-if="segment.quantity !== 0" class="flex flex-wrap gap-[20px]">
                                            <li v-for="(sub, i) in main.children" :key="i">
                                                <span v-if="sub.isColor" @click="changeSelect(main.id, sub.id, index)" :class="`cursor-pointer block h-[50px] w-[50px] rounded-[11px] p-2 ${sub.isSelected ? 'border border-primary' : ''}`" :style="{ backgroundColor: sub.color }"></span>
                                                <span v-else-if="main.display_as_text === 0" @click="changeSelect(main.id, sub.id, index)" :class="`${sub.isSelected ? 'border-primary' : 'border-[#C1C1C1]'} border h-[50px] flex items-center px-4 cursor-pointer min-w-[60px] rounded-[11px]`">{{ currentLanguage === 'ar' ? sub.name_ar : sub.name_en }}</span>
                                                <span v-else class="bg-primaryLight3 text-primary py-[0.220rem] px-2 rounded-[0.375rem]">{{ currentLanguage === 'ar' ? sub.name_ar : sub.name_en }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div class=" w-[90%] mx-auto py-3  border-t-[3px] pt-8 flex flex-wrap gap-[20px] ">
                        <button type="button" @click="() => isOrderFormModalOpen = false && changeOrderModalState(false)"
                            class=" px-[40px] flex justify-center items-center border border-primary text-primary rounded-[7px] h-[55px] w-full lg:w-fit hover:opacity-60 ">
                            <img src="../../../assets/icons/down.svg" alt
                                class=" rotate-[270deg] object-contain w-[20px] h-[16px] " width="9px" height="16px" />
                            <span> {{ $t("general.return") }}
                            </span>
                        </button>
                        <button @click="createOrderDetails()" class="px-[50px] py-[12px] bg-primary text-white w-full font-semibold rounded-md md:w-fit">{{ $t('general.confirm_order') }}</button>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import timesIcon from "@/assets/icons/times_red.svg";
import { APIREQUESTS, MAINROLES, constructQueryString, getPriceAfterDiscount } from "@/helpers";
import { Modal , Breadcrumb } from "@/components";
import { useGlobalStore } from "@/store/Modules/global";
export default {
    components:{
        Breadcrumb,
    },
    data() {
        return {
            timesIcon,
            offerOrderDetails: [],
            orderID: this.orderID,
            quantity: this.maxQuantity || 1,
            quantityEdited: parseInt(this.QuantityBeforeEdit, 10) || 1,
            globalStore: useGlobalStore(),
            currentLanguage: this.globalStore?.localStorageCopy?.language || 'ar',
            attributes: [],
            orderDetailsData: [],
            newOffer: {},
            branchDiscount: 0,
            OfferOrder: [],
            minQuantity: this.minQuantity || 1,
            maxQuantityOrder: this.maxQuantity || 1,
            unique_id: 1,
            isOrderFormModalOpen: false,
            cartID: null,
            quantitySegments: [
                { 
                    quantity: this.maxQuantity || 1,
                    order_id: Date.now(),
                    unique_id: this.unique_id,
                    attributes: this.attributes,
                    isSelected: false,
                    offerId: JSON.parse(localStorage.getItem('chosenOffer')).id,
                    offer_details: JSON.parse(localStorage.getItem('chosenOffer'))
                }
            ],
        }
    },
    props: {
        QuantityBeforeEdit: {
            type: Number,
            default: 1,
            required: false
        },
        isOrderFormModalOpen: {
            type: Boolean,
            default: false,
            required: true
        },
        isNewOrder: {
            type: Boolean,
            default: false,
            required: false
        },
        changeOrderModalState: {
            type: Function,
            required: true
        },
        productData: {
            type: Object,
            default: {},
            required: false
        },
        orderData: {
            type: Object,
            default: {},
            required: false
        },
        maxQuantity: {
            type: Number,
            default: 1,
            required: false
        },
        appendOffer: {
            type: Boolean,
            default: false,
            required: false
        },
        offer: {
            type: Object,
            default: {},
            required: false
        }
    },
    computed: {
        breadcrumbLinks() {
      return [
        { text: this.$t("Breadcrumb.home"), path: "/" },
        { text: this.$t("Breadcrumb.enter_order_details"), path: "" },
      ];
    },
    },
    methods: {
        totalPrice(){
            if(localStorage.getItem('branch') !== "main"){
                const branch = JSON.parse(localStorage.getItem('branch'));
                this.branchDiscount = Math.abs(branch.discount) / 100;
            }else{
                this.branchDiscount = 0;
            }
            let price = JSON.parse(localStorage.getItem('chosenOffer')).new_price;
            if(this.productData.discount){
                price = price * (1 - parseFloat(this.productData.discount) / 100);
            }
            return price === 0 ? 0 : Math.ceil(price * (1 - this.branchDiscount));
        },
        GetAttributesFromCart(){
            this.cartID = this.productItem.id;
            this.makeRequest({
                owner: this.MAINROLES.user,
                url: this.APIREQUESTS.user.getAttributesFromCart.url + '/' + this.cartID + '/attributes',
                method: this.APIREQUESTS.user.getAttributesFromCart.method,
            })
            .then((res) => {
                this.attributes = res.data;
                // this.attributesCart = Array(this.productItem.product.details.length).fill(res.data);
                this.attributesSelectedCart = this.$props.offer.attributes;
                // Initialize mergedAttributes with the selected attributes
                this.mergedAttributes = JSON.parse(JSON.stringify(this.attributesSelectedCart));

                // Loop through each attribute in the allAttributes list
                this.attributes.forEach(attribute => {
                // Find the matching parent in mergedAttributes
                const selectedParent = this.mergedAttributes.find(
                    selectedAttr => selectedAttr.parent.id === attribute.id
                );

                if (selectedParent) {
                    // If a matching parent is found, merge the children
                    attribute.children.forEach(child => {
                    const isSelected = selectedParent.id === child.id;

                    // Mark is_selected based on whether it's in selectedAttributes
                    selectedParent.children = selectedParent.children || [];
                    if (!selectedParent.children.some(existingChild => existingChild.id === child.id)) {
                        selectedParent.children.push({ ...child, is_selected: isSelected });
                    }
                    });
                } else {
                    // If no matching parent is found, add the entire attribute as-is
                    this.mergedAttributes.push({
                    parent: { id: attribute.id, name_ar: attribute.name_ar, name_en: attribute.name_en },
                    children: attribute.children.map(child => ({ ...child, is_selected: false }))
                    });
                }
                });
    
            })
            .catch((err) => {
                console.error("err", err);
            })
        },
        validateAttributes() {
        return this.quantitySegments.every(segment => {
            return segment.attributes.every(attr => {
                if (attr.display_as_text !== 1) {
                    return attr.children.some(child => child.isSelected);
                } else {
                    return true;
                }
                });
            });
        },
        // changeOrderModalState(val){
        //     this.isOrderFormModalOpen = val;
        // },
        createOrderDetails(){
            this.isSelected = false;            
            return this.isNewOrder === true ? this.confirmActionForOfferAdd() : this.confirmActionForOffer()
        },
        confirmActionForOfferAdd(data){

            this.offerOrderDetails = this.globalStore.orderDetailsOffer;
            if (!this.validateAttributes() && this.productData.attributes.length > 0) {
                this.notify({ type: 'error', msg: this.$t('general.select_all_attributes') });
                return; // Stop execution if validation fails
            }else if(this.productData.attributes.length === 0 && this.appendOffer === false){
                this.$emit('confirmActionForOffer');
                const thePath = `${this.$route.path}/order-details`
                useGlobalStore().setOrderDetailsOffer(this.quantitySegments);
                this.$router.push(thePath);
                this.changeOrderModalState(false);
            }else if(this.productData.attributes.length === 0 && this.appendOffer === true){
                if (this.quantitySegments.length > 0) {
                    this.offerOrderDetails.push(...this.quantitySegments);
                    useGlobalStore().setOrderDetailsOffer(this.offerOrderDetails);
                }
                this.$emit('confirmActionForOffer');
                this.changeOrderModalState(false);
            }
            if(this.productData.attributes.length !== 0 && this.appendOffer === false){
                this.$emit('confirmActionForOffer');
                const thePath = `${this.$route.path}/order-details`
                this.$router.push(thePath);
                this.changeOrderModalState(false);
            }else{
                if(this.newOffer.length > 0){
                    if (Array.isArray(this.newOffer)) {
                        this.offerOrderDetails.push(...this.newOffer);
                    } else {
                        this.offerOrderDetails.push(this.newOffer);
                    }
                    useGlobalStore().setOrderDetailsOffer(this.offerOrderDetails);
                    this.$emit('confirmActionForOffer');
                    this.changeOrderModalState(false);
                }
            }
            // this.productDataWholesale = useGlobalStore().productData;
            // this.orderDetailsDataWholesale = useGlobalStore().orderDetailsWholesale;
            // const selectedAttributes = this.getSelectedAttributes();
            // let existingOrderIndex = -1;
            // // Check if the selected attributes already exist in orderDetailsData
            // const minQuantity = parseInt(localStorage.getItem('minQuantity'), 10);
            // if(this.quantity < minQuantity && minQuantity !== null){
            //     this.notify({type: 'error', msg: this.$t('general.min_quantity_is') + minQuantity});
            //     return;
            // }
            // if(this.orderDetailsDataWholesale.length > 0){
            // existingOrderIndex = this.orderDetailsDataWholesale?.findIndex(order => 
            //     order?.attributes_products &&
            //     JSON.stringify(
            //     order?.attributes_products?.map(attr => attr.id)
            //     ) === JSON.stringify(
            //         selectedAttributes?.map(attr => 
            //         attr?.children?.filter(child => child?.isSelected).map(child => child.id)
            //         ).flat()
            //     )
            // );
            // }
                
            //     if(existingOrderIndex !== -1){
            //         // If found, increase the quantity of the existing order
            //         // this.quantity = this.orderDetailsDataWholesale[existingOrderIndex].quantity + this.quantity;
            //         this.orderDetailsDataWholesale[existingOrderIndex].quantity += this.quantity;
            //         this.globalStore.setOrderDetailsWholesale(this.orderDetailsDataWholesale);
            //         this.quantity = this.isNewOrder === true ? 1 : parseInt(this.QuantityBeforeEdit, 10);
            //     }else{
            //         // If not found, create a new orderDetails object
            //         const orderDetails = {
            //             id: Date.now(),
            //             quantity: this.quantity,
            //             attributes: selectedAttributes,
            //             productData: this.productDataWholesale
            //         };

            //         // New code to flatten attributes and assign to order.attributes_products
            //         orderDetails.attributes_products = selectedAttributes.flatMap(attribute => 
            //             attribute.children.map(child => ({
            //                 ...child,
            //                 name: this.currentLanguage === 'ar' ? child.name_ar : child.name_en,
            //             }))
            //         );
            //         this.orderDetailsDataWholesale.push(orderDetails);
            //         this.quantity = this.isNewOrder === true ? 1 : parseInt(this.QuantityBeforeEdit, 10);
            //         this.globalStore.setOrderDetailsWholesale(this.orderDetailsDataWholesale);
            //     }
            // this.changeOrderModalState(false);
            // localStorage.setItem('minQuantity',null);
            // this.$emit('confirmActionForWholesaleAdd', this.orderDetailsDataWholesale);
        },
        getSelectedAttributes() {
            return this.quantitySegments.map(segment => ({
                attributes: this.attributes
                    .map(attr => ({
                        ...attr,
                        children: attr.children.filter(child => child.isSelected || child.is_selected),
                        name: this.currentLanguage === 'ar' ? attr.name_ar : attr.name_en
                    }))
                    .filter(attr => attr.children.length > 0), // Only include attributes with selected children
                quantity: segment.quantity // Include the quantity for this segment
            })).filter(segment => segment.attributes.length > 0); // Only include segments with selected attributes
        },
        confirmActionForAdd(){
            const selectedAttributes = this.getSelectedAttributes();
            this.orderDetailsData = this.globalStore.orderDetails;

            // Check if the selected attributes already exist in orderDetailsData
            const existingOrderIndex = this.orderDetailsData.findIndex(order => 
                order.attributes_products &&
                JSON.stringify(
                    order.attributes_products.map(attr => attr.id)
                ) === JSON.stringify(
                    selectedAttributes.map(attr => 
                    attr.children.filter(child => child.isSelected).map(child => child.id)
                    ).flat()
                )
            );

 
            if(existingOrderIndex !== -1){
                // If found, increase the quantity of the existing order
                this.quantity = this.orderDetailsData[existingOrderIndex].quantity + this.quantity;
                this.orderDetailsData[existingOrderIndex].quantity += this.quantity;
            }else{
                // If not found, create a new orderDetails object
                const orderDetails = {
                    id: Date.now(),
                    quantity: this.quantity,
                    attributes: selectedAttributes,
                    productData: this.productData
                };

                // New code to flatten attributes and assign to order.attributes_products
                orderDetails.attributes_products = selectedAttributes.flatMap(attribute => 
                    attribute.children.map(child => ({
                        ...child,
                        name: this.currentLanguage === 'ar' ? child.name_ar : child.name_en,
                    }))
                );

                this.orderDetailsData.push(orderDetails);
            }
            this.quantity = this.isNewOrder === true ? 1 : parseInt(this.QuantityBeforeEdit, 10);
            this.globalStore.setOrderDetails(this.orderDetailsData);
    
            this.$emit('confirmActionForAdd', this.orderDetailsData);
            this.changeOrderModalState(false);
            this.isSelected = false;
        },
        confirmActionForWholesale() {
            this.isSelected = false;
            this.orderDetailsData = this.globalStore.orderDetailsWholesale;
            const selectedAttributes = this.getSelectedAttributes();
            // Find the index of the current order with matching selected attributes
            const matchingOrderIndex = this.orderDetailsData.findIndex(order => 
                order.attributes_products &&
                JSON.stringify(order.attributes_products.map(attr => attr.id)) === 
                JSON.stringify(
                    selectedAttributes.map(attr => 
                        attr.children.filter(child => child.isSelected).map(child => child.id)
                    ).flat()
                )
            );

            // Find the index of the order before editing
            const currentOrderIndex = this.orderDetailsData.findIndex(order => 
                order.id === parseInt(localStorage.getItem('orderID'), 10)
            );
            // if statement to check if the matchingOrderIndex exists or not if it exists then check if the currentOrderIndex is the same as the matchingOrderIndex
            // if it is the same then update the quantity and attributes and attributes_products
            // if it is not the same then update the quantity and attributes and attributes_products
            if(currentOrderIndex === matchingOrderIndex){
                this.orderDetailsData[currentOrderIndex].quantity = this.quantity;
                this.orderDetailsData[currentOrderIndex].attributes = selectedAttributes;
                this.orderDetailsData[currentOrderIndex].attributes_products = selectedAttributes.flatMap(attribute => 
                    attribute.children.map(child => ({
                        ...child,
                        name: this.currentLanguage === 'ar' ? child.name_ar : child.name_en,
                    }))
                );
                this.globalStore.setOrderDetails(this.orderDetailsData);
            }
            // if statement to check if the matchingOrderIndex exists and if the currentOrderIndex is not the same as the matchingOrderIndex
            // if it is not the same then update the quantity and attributes and attributes_products
            // if the matchingOrderIndex does not exist then do nothing
            // (New Attributes) For the case where not exists mathcing, just update the quantity and new attributes
            if(matchingOrderIndex === -1 && currentOrderIndex !== matchingOrderIndex){
                this.orderDetailsData[currentOrderIndex].quantity = this.quantity;
                this.orderDetailsData[currentOrderIndex].attributes = selectedAttributes;
                this.orderDetailsData[currentOrderIndex].attributes_products = selectedAttributes.flatMap(attribute => 
                    attribute.children.map(child => ({
                        ...child,
                        name: this.currentLanguage === 'ar' ? child.name_ar : child.name_en,
                    }))
                );
                this.globalStore.setOrderDetails(this.orderDetailsData);
            }
            // if statement to check if the matchingOrderIndex exists
            // and if the currentOrderIndex is not the same as the matchingOrderIndex
            // if it is not the same then update the quantity and attributes and attributes_products
            // and remove the currentOrderIndex from the orderDetailsData
            // This for the case of matching the attributes and then add a new quantity to the matchingOrderIndex
            if(matchingOrderIndex !== -1 && currentOrderIndex !== matchingOrderIndex){
                this.orderDetailsData[matchingOrderIndex].quantity += this.quantity;
                this.orderDetailsData[matchingOrderIndex].attributes = selectedAttributes;
                this.orderDetailsData[matchingOrderIndex].attributes_products = selectedAttributes.flatMap(attribute => 
                    attribute.children.map(child => ({
                        ...child,
                        name: this.currentLanguage === 'ar' ? child.name_ar : child.name_en,
                    }))
                );
                this.orderDetailsData = this.orderDetailsData.filter(item => item !== this.orderDetailsData[currentOrderIndex])
                this.globalStore.setOrderDetails(this.orderDetailsData);
            }
            this.$emit('confirmActionForWholesale');
            localStorage.removeItem('QuantityBeforeEdit');
            this.changeOrderModalState(false);
            this.$destroy();
        },
        confirmAction() {
            this.isSelected = false;
            this.orderDetailsData = this.globalStore.orderDetails;
            const selectedAttributes = this.getSelectedAttributes();
            // Find the index of the current order with matching selected attributes
            const matchingOrderIndex = this.orderDetailsData.findIndex(order => 
                order.attributes_products &&
                JSON.stringify(order.attributes_products.map(attr => attr.id)) === 
                JSON.stringify(
                    selectedAttributes.map(attr => 
                        attr.children.filter(child => child.isSelected).map(child => child.id)
                    ).flat()
                )
            );

            // Find the index of the order before editing
            const currentOrderIndex = this.orderDetailsData.findIndex(order => 
                order.id === parseInt(localStorage.getItem('orderID'), 10)
            );
            // if statement to check if the matchingOrderIndex exists or not if it exists then check if the currentOrderIndex is the same as the matchingOrderIndex
            // if it is the same then update the quantity and attributes and attributes_products
            // if it is not the same then update the quantity and attributes and attributes_products
            if(currentOrderIndex === matchingOrderIndex){
                this.orderDetailsData[currentOrderIndex].quantity = this.quantity;
                this.orderDetailsData[currentOrderIndex].attributes = selectedAttributes;
                this.orderDetailsData[currentOrderIndex].attributes_products = selectedAttributes.flatMap(attribute => 
                    attribute.children.map(child => ({
                        ...child,
                        name: this.currentLanguage === 'ar' ? child.name_ar : child.name_en,
                    }))
                );
                this.globalStore.setOrderDetails(this.orderDetailsData);
            }
            // if statement to check if the matchingOrderIndex exists and if the currentOrderIndex is not the same as the matchingOrderIndex
            // if it is not the same then update the quantity and attributes and attributes_products
            // if the matchingOrderIndex does not exist then do nothing
            // (New Attributes) For the case where not exists mathcing, just update the quantity and new attributes
            if(matchingOrderIndex === -1 && currentOrderIndex !== matchingOrderIndex){
                this.orderDetailsData[currentOrderIndex].quantity = this.quantity;
                this.orderDetailsData[currentOrderIndex].attributes = selectedAttributes;
                this.orderDetailsData[currentOrderIndex].attributes_products = selectedAttributes.flatMap(attribute => 
                    attribute.children.map(child => ({
                        ...child,
                        name: this.currentLanguage === 'ar' ? child.name_ar : child.name_en,
                    }))
                );
                this.globalStore.setOrderDetails(this.orderDetailsData);
            }
            // if statement to check if the matchingOrderIndex exists
            // and if the currentOrderIndex is not the same as the matchingOrderIndex
            // if it is not the same then update the quantity and attributes and attributes_products
            // and remove the currentOrderIndex from the orderDetailsData
            // This for the case of matching the attributes and then add a new quantity to the matchingOrderIndex
            if(matchingOrderIndex !== -1 && currentOrderIndex !== matchingOrderIndex){
                this.orderDetailsData[matchingOrderIndex].quantity += this.quantity;
                this.orderDetailsData[matchingOrderIndex].attributes = selectedAttributes;
                this.orderDetailsData[matchingOrderIndex].attributes_products = selectedAttributes.flatMap(attribute => 
                    attribute.children.map(child => ({
                        ...child,
                        name: this.currentLanguage === 'ar' ? child.name_ar : child.name_en,
                    }))
                );
                this.orderDetailsData = this.orderDetailsData.filter(item => item !== this.orderDetailsData[currentOrderIndex])
                this.globalStore.setOrderDetails(this.orderDetailsData);
            }
            this.$emit('confirmAction');
            localStorage.removeItem('QuantityBeforeEdit');
            this.changeOrderModalState(false);
            this.$destroy();
        },
        validateQuantity(event, index) {
            let value = parseInt(event.target.value, 10);
            // Prevent negative values or empty input
            if (value < 1 || isNaN(value)) {
                value = 1;
            }
            // Update the model value
            this.quantitySegments[index].quantity = value;
        },
        changeSelect(mainId , subId , index){
            // Update attributes for the specific segment
            this.quantitySegments[index].attributes.map((item)=>{
                if(item.id == mainId ){
                    item.children = item.children.map((child)=>{
                        if(child.id == subId){
                            child.isSelected = true; // Set selected for the clicked child
                        }else{
                            child.isSelected = false; // Deselect other children
                        }
                        return child;
                    });
                }
                return item;
            });
            // Reset isSelected only for the current segment
            this.quantitySegments.forEach((segment, idx) => {
                if (idx !== index) {
                    segment.isSelected = false; // Only reset other segments
                }
            });
            if(this.appendOffer === false){
                useGlobalStore().setOrderDetailsOffer(this.quantitySegments.map(item => ({
                ...item,
                    offerId: JSON.parse(localStorage.getItem('chosenOffer')).id,
                    offer_details: JSON.parse(localStorage.getItem('chosenOffer')),
                    order_id: Date.now(),
                    unique_id: this.unique_id
                })));
            }else{
                this.newOffer = this.quantitySegments.map(item => ({
                    ...item,
                    offerId: JSON.parse(localStorage.getItem('chosenOffer')).id,
                    offer_details: JSON.parse(localStorage.getItem('chosenOffer')),
                    order_id: Date.now(),
                    unique_id: this.unique_id
                }));
            }
        },
        changeSelectForEdit(mainId, subId) {
            this.attributes = this.attributes.map((item) => {
                if(item.id == mainId ){
                item.children = item.children.map((child)=>{
                    if(child.id == subId){
                        child.is_selected = true;
                    }else{
                        child.is_selected = false;
                    }
                    return child
                })
                }
                return item;
            });
        },
        increaseQuantity(index) {
            // Disable increase button, do nothing
        },

        decreaseQuantity(index) {
            const currentQuantity = this.quantitySegments[index].quantity;
            if(this.productData.attributes.length === 0){
                this.notify({ type: 'error', msg: this.$t('general.cannot_decrease_quantity') });
                return;
            }
            // Decrease the quantity of the current segment
            if (currentQuantity > 0) {
                this.quantitySegments[index].quantity = currentQuantity - 1;
                // if the quantity is 1, remove the segment
                if(currentQuantity === 1){
                    this.quantitySegments[index-1].quantity += 1;
                    this.quantitySegments[index+1].quantity -= 1;
                    this.quantitySegments[index].quantity = 0;
                }
                // if the quantity is not 0, add 1 to the next segment
                if(currentQuantity !== 0){
                    if (index < this.quantitySegments.length) {
                        // if this is the last segment, add 1 to the quantity to a new segment
                        if (index === this.quantitySegments.length - 1) {

                            if(index > 0 && index < this.quantitySegments.length - 1){
                                this.quantitySegments[index-1].quantity += 1;
                                this.quantitySegments.splice(index, 1);
                            }else{
                                this.quantitySegments.push({ quantity: 1, attributes: this.attributes.map(item => ({
                                    ...item,
                                    children: item.children.map(child => ({
                                        ...child,
                                        isSelected: false,
                                        offerId: JSON.parse(localStorage.getItem('chosenOffer')).id,
                                        offer_details: JSON.parse(localStorage.getItem('chosenOffer')),
                                        order_id: Date.now(),
                                        unique_id: this.unique_id
                                    }))
                                })) , isSelected: false
                             });
                            }
                        }else {
                            this.quantitySegments[index+1].quantity += 1; // Add 1 to the next segment
                        }
                    } else {
                        this.quantitySegments.push({ quantity: 1, attributes: this.attributes.map(item => ({
                            ...item,
                            children: item.children.map(child => ({
                                ...child,
                                isSelected: false,
                                offerId: JSON.parse(localStorage.getItem('chosenOffer')).id,
                                offer_details: JSON.parse(localStorage.getItem('chosenOffer')),
                                order_id: Date.now()
                            }))
                        })) , isSelected: false,
                        offerId: JSON.parse(localStorage.getItem('chosenOffer')).id,
                        offer_details: JSON.parse(localStorage.getItem('chosenOffer')),
                        order_id: Date.now(),
                        unique_id: this.unique_id
                             }); // If it's the last segment, just add a new one
                    }
                }
            }
            if(this.appendOffer === true){
                this.newOffer = this.quantitySegments;
            }

        },
        updateAttributesFromProductData(newVal) {
            if (newVal && newVal.attributes) {
                if(this.isNewOrder === false){
                    this.quantity = parseInt(this.QuantityBeforeEdit, 10);
                }
                this.attributes = newVal.attributes.map(attr => {
                    return {
                        ...attr,
                        name: this.currentLanguage === 'ar' ? attr.name_ar : attr.name_en,
                        display_as_text: attr.display_as_text,
                        attributes_selected: attr.attributes_selected,
                        children: attr.children.map(child => ({
                            ...child,
                            isSelected: this.isNewOrder ? false : child.isSelected,
                            isColor: child.color !== null, // Determine if it's a color
                        }))
                    };
                });
            }
        },
        updateAttributesFromOrderData(newVal) {
            if (newVal && newVal.attributes) {
                this.attributes = newVal.attributes.map(attr => {
                    return {
                        ...attr,
                        name: this.currentLanguage === 'ar' ? attr.name_ar : attr.name_en,
                        display_as_text: attr.display_as_text,
                        children: attr.children.map(child => ({
                            ...child,
                            isColor: child.color !== null, // Determine if it's a color
                            isSelected: this.isNewOrder ? false : child.isSelected  // Use isSelected from order data
                        }))
                    };
                });
            }
        },
    },
    watch: {
        quantitySegments: {
            immediate: true,
            handler(newVal) {
                if(this.isNewOrder === true && this.isOrderFormModalOpen === false){
                    setInterval(() => {
                        this.quantitySegments = this.quantitySegments.filter(segment => segment.quantity !== 0);
                        this.quantity = this.maxQuantity;
                    }, 2000);
                }
            }
        },
        productData: {
            immediate: true,
            handler(newVal) {
                this.updateAttributesFromProductData(newVal);
            }
        },
        orderData: {
            immediate: true,
            handler(newVal) {
                this.updateAttributesFromOrderData(newVal);
            }
        }
    },
    mounted() {
        if(this.$route.productItem){
            this.GetAttributesFromCart();
        }else{
            this.unique_id = Date.now();
            this.quantity = this.maxQuantity;
            this.attributes = this.attributes.map(item => ({
                    ...item,
                    children: item.children.map(child => ({
                        ...child,
                        isSelected: false
                    }))
                }));
            if (this.changeOrderModalState === false){
                setTimeout(() => {
                    this.quantity = 0;
                }, 500);
            }
            if(this.isNewOrder === true){
                this.isSelected = false;
                this.quantity = this.maxQuantity || 1;
            }else{
                this.quantity = parseInt(this.QuantityBeforeEdit, 10);
            }
            // Initialize quantitySegments with one segment of 50
            this.quantitySegments = [{ quantity: this.maxQuantity || 1, 
                    attributes: this.attributes,
                    offerId: JSON.parse(localStorage.getItem('chosenOffer')).id,
                    offer_details: JSON.parse(localStorage.getItem('chosenOffer')),
                    order_id: Date.now(),
                    unique_id: this.unique_id
            }];
        }
    }
}
</script>

<style></style>